import { Dialog, DialogTitle, DialogContent, Box, Typography, ThemeProvider, createTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import ssoIcon from 'assets/images/sso-icon.svg';

const ssoDialogTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiDialog-paper': {
            borderRadius: '20px',
            minWidth: '340px',
            position: 'relative',
          },
          '& .MuiDialogTitle-root': {
            fontFamily: 'Rubik-Medium !important',
            fontSize: '18px',
            color: '#277134',
            textAlign: 'center',
            textTransform: 'uppercase',
            userSelect: 'none',
            padding: '20px 16px 4px',
          },
          '& .sso-dialog-close': {
            position: 'absolute',
            top: 8,
            right: 8,
            cursor: 'pointer',
            color: '#999',
            '&:hover': {
              color: '#277134',
            },
          },
        },
      },
    },
  },
});

const SSOProviderModal = ({ open, providers, onClose, onSelect }) => {
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={ssoDialogTheme}>
      <Dialog maxWidth="xs" open={open} onClose={onClose}>
        <ClearIcon className="sso-dialog-close" onClick={onClose} />
        <DialogTitle>{t('button.ssoLogin')}</DialogTitle>
        <DialogContent sx={{ px: 3, pb: 3 }}>
          {providers.map((p) => (
            <Box
              key={p.name}
              onClick={() => onSelect(p.name)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '14px 16px',
                border: '2px solid #277134',
                borderRadius: '10px',
                mb: 1.5,
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:hover': {
                  backgroundColor: '#e8f5e9',
                  borderColor: '#1b5428',
                },
              }}
            >
              <img src={ssoIcon} alt="" width="28" height="28" style={{ marginRight: 14, flexShrink: 0 }} />
              <Box>
                <Typography sx={{ fontFamily: 'Rubik-Medium', fontWeight: 600, color: '#277134', fontSize: 15 }}>
                  {p.name}
                </Typography>
                <Typography sx={{ color: '#999', fontSize: 12, mt: 0.3 }}>
                  {t('button.ssoProviderHint', { provider: p.name })}
                </Typography>
              </Box>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};

export default SSOProviderModal;
